import { checkPassword } from '../../lib/passwordPolicy';

/**
 * Live checklist of what a new password needs, shown under the password field
 * on sign-up and password reset. Each rule ticks as soon as it is met.
 * Pair the field with `aria-describedby={id}` so screen readers read it too.
 */
export function PasswordRules({ password, id = 'password-rules', tone = 'default' }: {
  password: string;
  id?: string;
  tone?: 'default' | 'inverted';
}) {
  const inverted = tone === 'inverted';
  const metColor = inverted ? 'rgb(var(--cream-bright))' : 'var(--success-fg, rgb(var(--success)))';
  const todoColor = inverted ? 'rgba(255, 252, 219, .65)' : 'var(--text-dim)';
  return (
    <ul id={id} aria-live="polite" className="flex flex-col gap-1 -mt-1" style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--fs-caption)' }}>
      {checkPassword(password).map(({ rule, met }) => (
        <li key={rule.id} className="flex items-center gap-1.5" style={{ color: met ? metColor : todoColor }}>
          <span aria-hidden="true" className="inline-flex w-3.5 justify-center font-semibold">{met ? '✓' : '·'}</span>
          <span>{rule.label}</span>
          <span className="sr-only">{met ? '(done)' : '(still needed)'}</span>
        </li>
      ))}
    </ul>
  );
}

export default PasswordRules;
